import {Component, model, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-dropdown-inline-button",
    imports: [],
    templateUrl: "./dropdown-inline-button.component.html",
    styleUrl: "./dropdown-inline-button.component.scss",
})
export class DropdownInlineButtonComponent {
    readonly $expanded = model(false, {alias: "expanded"})

    toggle() {
        this.$expanded.update((expanded) => !expanded)
    }
}
